<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          :label="FieldLabel.SNILS"
          v-mask="Mask.SNILS"
          outlined
          :disabled="v.mrpDisabled.$model.includes(FieldName.SNILS)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :label="FieldLabel.INN"
          v-mask="Mask.INN"
          outlined
          :disabled="v.mrpDisabled.$model.includes(FieldName.INN)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>

    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе физического лица"
    />
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  PERSON_NAME,
  EMAIL,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  SNILS_ROD,
  TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import { FieldLabel, FieldName, Mask } from '@/constants';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import cloneDeep from 'clone-deep';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',

  snils: '',
  inn: '',
  email: '',

  trustee: cloneDeep(mrpaTrusteeModel),
  mrpDisabled: [],
};

export const getPersonValidation = (person) => ({
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
    TRAILING_AND_LEADING_SPACES,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
    TRAILING_AND_LEADING_SPACES,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
    TRAILING_AND_LEADING_SPACES,
  },

  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN_ROD,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
    TRAILING_AND_LEADING_SPACES,
  },

  trustee: getMrpaTrusteeValidation(person.trustee),
  mrpDisabled: {},
});

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    MrpaTrustee,
  },
  data: () => ({
    Mask,
    FieldLabel,
    FieldName,
    getValidationErrorText,
  }),
};
</script>
